/** @format */

import React, { useContext } from 'react';
import { NavigationContext } from '@context/navigation-context';
import Translate from '@components/translation/translate-text-wrapper';
import {
  getRelativeLanguagePath,
  getRegionName,
} from './language-selector-utils';
import {
  LocaleLanguage,
  NavigationData,
} from '@context/navigation-context-modals';
import { safeUrl } from '@services/drupal-services';

interface LanguageRegionProps {
  region: string;
}

/**
 * Language Region.
 *
 * @param
 */
const LanguageRegion = (props): JSX.Element | null => {
  const { region }: LanguageRegionProps = props;
  const navigationData: NavigationData = useContext(NavigationContext);
  const { locale_languages: localeLanguages }: LocaleLanguage[] =
    navigationData;
  const path = getRelativeLanguagePath(localeLanguages);

  /**
   * Render.
   */
  if (localeLanguages) {
    return (
      <div className="region">
        <h3>
          <Translate>{getRegionName(region)}</Translate>
        </h3>
        <ul>
          {localeLanguages.map((language: LocaleLanguage) => {
            const {
              locale_language_region: localeRegion,
              locale_language_code: id,
              language_display_text: translatedName,
              locale_flag: flag,
            } = language;

            let languagePath = id === 'en' ? `${path}` : `/${id}${path}`;
            languagePath = languagePath === '' ? '/' : languagePath;

            if (localeRegion === region) {
              return (
                <li hrefLang={id} data-drupal-link-system-path={path} key={id}>
                  <a
                    href={languagePath}
                    hrefLang={id}
                    data-drupal-link-system-path={path}>
                    <img
                      data-src={safeUrl(
                        `/themes/custom/varian/webpack/scripts/components/language-selector/images/flags/${flag}.png`
                      )}
                      className="lazy"
                      alt=""
                    />
                    {translatedName}
                  </a>
                </li>
              );
            }
            return null;
          })}
        </ul>
      </div>
    );
  }
  return null;
};
export default LanguageRegion;
